export const AI_USAGE_TABS = ['company', 'mine'] as const;

export type AiUsageTab = (typeof AI_USAGE_TABS)[number];

export const isAiUsageTab = (value: string): value is AiUsageTab => AI_USAGE_TABS.some((tab) => tab === value);
